"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOverview = void 0;
const uniqueNodeKeySet_1 = require("./uniqueNodeKeySet");
const defaultSeverityCount = () => ({
    totalCurrent: 0,
    totalLast: 0,
    numNew: 0,
    numFixed: 0
});
const getNodeCount = (result) => {
    return result.uniques.flatMap(n => n).length;
};
const calculateOverview = ({ currentResultsMap, previousResultsMap }) => {
    let fixedIssues = 0;
    let newIssues = 0;
    const currentResults = [...currentResultsMap.values()];
    // Severities (from https://github.com/dequelabs/dequeway#a-note-on-impact-levels):
    const numIssueSeverity = {
        minor: defaultSeverityCount(),
        moderate: defaultSeverityCount(),
        serious: defaultSeverityCount(),
        critical: defaultSeverityCount()
    };
    const currResultLength = currentResults.length;
    const currUniqueIssues = currentResults.flatMap(v => v.uniques).length;
    /* sum of all the duplicates within the duplicates object */
    const currDuplicateIssues = currentResults
        .flatMap(a => Object.values(a.duplicates))
        .reduce((a, b) => a + b, 0);
    const currTotalIssues = currUniqueIssues + currDuplicateIssues;
    if (!previousResultsMap) {
        /* if there is no previous session, then all issues are new issues */
        for (const result of currentResults) {
            const impact = result.impact;
            const nodeCount = getNodeCount(result);
            newIssues += nodeCount;
            numIssueSeverity[impact].numNew += nodeCount;
            numIssueSeverity[impact].totalCurrent += nodeCount;
        }
    }
    else {
        /* if there is a previous session, then we need to compare the current results to the previous results */
        for (let i = 0; i < currResultLength; i++) {
            const currResult = currentResults[i];
            const prevResult = previousResultsMap.get(currResult.id);
            const impact = currResult.impact;
            /* if the rule ID is not found in the previous results, then it is a new issue */
            if (!prevResult) {
                const currNodeCount = getNodeCount(currResult);
                newIssues += getNodeCount(currResult);
                numIssueSeverity[impact].numNew += currNodeCount;
                numIssueSeverity[impact].totalCurrent += currNodeCount;
            }
            else {
                /* the rule ID is found in the previous results, then we need to compare the nodes */
                const currNodes = currResult.uniques;
                const prevNodes = prevResult.uniques;
                const prevNodeKeys = uniqueNodeKeySet_1.UniqueNodeKeySet.from(prevResult);
                for (let j = 0; j < currNodes.length; j++) {
                    const currNode = currNodes[j];
                    /* find the node in the previous results that matches the current node */
                    const previousNode = prevNodeKeys.getDuplicateFingerprint(currNode);
                    /* if the node is not found in the previous results, then it is a new issue */
                    if (!previousNode) {
                        newIssues += 1;
                        numIssueSeverity[impact].numNew += 1;
                        numIssueSeverity[impact].totalCurrent += 1;
                        continue;
                    }
                    numIssueSeverity[impact].totalCurrent += 1;
                }
                const currNodeKeys = uniqueNodeKeySet_1.UniqueNodeKeySet.from(currResult);
                /* we need to check if there are any nodes in the previous results that are not in the current results */
                for (let k = 0; k < prevNodes.length; k++) {
                    const prevNode = prevNodes[k];
                    /* find the node in the current results that matches the previous node */
                    const currentNode = currNodeKeys.getDuplicateFingerprint(prevNode);
                    numIssueSeverity[impact].totalLast += 1;
                    /* if the node is not found in the current results, then it is a fixed issue */
                    if (!currentNode) {
                        fixedIssues += 1;
                        numIssueSeverity[impact].numFixed += 1;
                    }
                }
            }
        }
        const previousResults = [...previousResultsMap.values()];
        /* we need to check if there are any rule IDs in the previous results that are not in the current results */
        for (let p = 0; p < previousResults.length; p++) {
            const hasCurrentResult = currentResultsMap.get(previousResults[p].id);
            const impactPrev = previousResults[p].impact;
            /* if the rule ID is not found in the current results, then it is a fixed issue */
            if (!hasCurrentResult) {
                fixedIssues += getNodeCount(previousResults[p]);
                numIssueSeverity[impactPrev].numFixed += getNodeCount(previousResults[p]);
                numIssueSeverity[impactPrev].totalLast += getNodeCount(previousResults[p]);
            }
        }
    }
    return {
        currTotalIssues,
        currDuplicateIssues,
        fixedIssues,
        newIssues,
        currUniqueIssues,
        numIssueSeverity
    };
};
exports.calculateOverview = calculateOverview;
//# sourceMappingURL=calculateOverview.js.map